import bookConfirmApi from '@/src/api/rtkQuery/bookConfirmApi'
import useGetItineraryId from '@/src/hooks/itinerary/useGetItineraryId'
import { RootState } from '@/src/redux/rootReducer'
import { useAppSelector } from '@/src/redux/store'
import { extractFlightInfo } from '@/src/utils/analytics/clevertap/itinerary'
import { useMemo } from 'react'
import useClevertapEvent from '..'

const useClevertapForConfirmation = () => {
    const { triggerEvent } = useClevertapEvent()
    const itineraryId = useGetItineraryId()

    const data = useAppSelector((state: RootState) => {
        const cachedData = bookConfirmApi.endpoints.getBookConfirm.select(itineraryId)(state)
        return cachedData?.status === 'fulfilled' ? cachedData.data : null
    })
    const { flightDetails: flights = [], searchCriteria = {} } = data || {}
    const { paxInfo, departDate, arrivalDate, international } = searchCriteria || {}
    const { adults, children, infants } = paxInfo || {}

    const { airline, airlineName, flightNumber } = useMemo(() => extractFlightInfo(flights || []), [flights])

    const origin = flights?.[0]?.from || 'N/A'
    const destination = flights?.[0]?.to || 'N/A'
    const tripType = arrivalDate ? 'RoundTrip' : 'OneWay'
    const routeType = international ? 'international' : 'domestic'
    const departureDate = departDate?.split('T')[0] || 'N/A'
    const returnDate = arrivalDate?.split('T')[0] || 'N/A'
    const dx = Math.floor((new Date(departureDate).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24))

    const triggerConfirmationEvent = (name: string, payload: any) => {
        const finalPayload = {
            ...payload,
            itineraryId,
            origin,
            destination,
            airline,
            airlineName,
            flightNumber,
            trip_type: tripType,
            route_type: routeType,
            adult_count: adults,
            child_count: children,
            infant_count: infants,
            departure_date: departureDate,
            return_date: returnDate,
            dx
        }

        triggerEvent(name, finalPayload)
    }

    return {
        triggerConfirmationEvent
    }
}

export default useClevertapForConfirmation
